import type { JobDetailsDisplayedEvent } from '@seek/data-tracking-event-catalogue';

import type { JobDetailsWorkArrangements } from 'src/graphql/graphql';

type ArrangementsType = NonNullable<
  JobDetailsDisplayedEvent['data']['workArrangements']
>[number];

const isValidJobMode = (
  workArrangement?: string | null,
): workArrangement is ArrangementsType => {
  const validJobModes = ['HYBRID', 'REMOTE', 'ONSITE'];
  return validJobModes.includes(workArrangement ?? '');
};

export const mapJobArrangementsType = (
  workArrangements: JobDetailsWorkArrangements['arrangements'],
): JobDetailsDisplayedEvent['data']['workArrangements'] =>
  workArrangements?.reduce<ArrangementsType[]>((acc, wa) => {
    if (isValidJobMode(wa?.type)) {
      acc.push(wa?.type);
    }
    return acc;
  }, []);
